<div *ngIf="showLoader" class="mask">
  <div class="container-fluid h-100">
    <div class="row h-100 justify-content-center align-items-center">
      <div class="col-auto">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  </div>
</div>
